/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#activity-item-wrapper[_ngcontent-%COMP%]{display:-ms-grid;display:grid;-ms-grid-columns:1fr;grid-template-columns:1fr;-ms-grid-rows:auto auto auto;grid-template-rows:auto auto auto;text-align:center;max-width:9rem}#activity-icon[_ngcontent-%COMP%]{display:inline-block;margin:.5rem auto}#count[_ngcontent-%COMP%]{margin-bottom:.2rem;height:1.1rem}#title[_ngcontent-%COMP%]{font-family:Nunito,Semi-Bold;font-size:.9rem;overflow-wrap:break-word}"];
export { styles as styles };
//# sourceMappingURL=activity-item.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/activity-registry/activity-item/activity-item.component.scss.shim.ngstyle.js
// module id = 1601
// module chunks = 26 27 28